import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ColorCard = ({ color, onEdit, onDelete }) => {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const handleDelete = () => {
    onDelete(color?.id);
    setShowDeleteConfirm(false);
  };

  return (
    <>
      <div className="bg-card border border-border rounded-lg overflow-hidden transition-all duration-150 hover:shadow-lg">
        <div className="relative h-40 overflow-hidden">
          {color?.swatchImage ? (
            <Image
              src={color?.swatchImage}
              alt={color?.swatchImageAlt}
              className="w-full h-full object-cover"
            />
          ) : (
            <div
              className="w-full h-full"
              style={{ backgroundColor: color?.hexCode }}
            />
          )}
          <div className="absolute top-2 right-2 flex gap-2">
            <button
              onClick={() => onEdit(color)}
              className="w-8 h-8 bg-surface/90 backdrop-blur-sm border border-border rounded-lg flex items-center justify-center transition-all duration-150 hover:bg-surface"
              aria-label="Edit color"
            >
              <Icon name="Edit2" size={14} />
            </button>
            <button
              onClick={() => setShowDeleteConfirm(true)}
              className="w-8 h-8 bg-surface/90 backdrop-blur-sm border border-border rounded-lg flex items-center justify-center transition-all duration-150 hover:bg-error hover:text-error-foreground"
              aria-label="Delete color"
            >
              <Icon name="Trash2" size={14} />
            </button>
          </div>
        </div>

        <div className="p-4 space-y-3">
          <div>
            <h3 className="text-base font-semibold text-text-primary mb-1">
              {color?.name}
            </h3>
            <div className="flex items-center gap-2">
              <code className="text-sm text-text-secondary font-mono">
                {color?.hexCode}
              </code>
              <div
                className="w-4 h-4 rounded border border-border"
                style={{ backgroundColor: color?.hexCode }}
              />
            </div>
          </div>

          {color?.group && (
            <div className="flex items-center gap-2">
              <Icon name="Tag" size={14} className="text-text-secondary" />
              <span className="text-xs text-text-secondary">{color?.group}</span>
            </div>
          )}

          <div className="flex items-center justify-between pt-2 border-t border-border">
            <div className="flex items-center gap-1 text-xs text-text-secondary">
              <Icon name="TrendingUp" size={14} />
              <span>{color?.usageCount} uses</span>
            </div>
            <div className="flex items-center gap-1 text-xs text-text-secondary">
              <Icon name="Calendar" size={14} />
              <span>{new Date(color.createdAt)?.toLocaleDateString()}</span>
            </div>
          </div>
        </div>
      </div>
      {showDeleteConfirm && (
        <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-[2000] flex items-center justify-center p-4">
          <div className="bg-card border border-border rounded-lg shadow-xl max-w-md w-full p-6">
            <div className="flex items-start gap-4 mb-4">
              <div className="w-10 h-10 bg-error/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name="AlertTriangle" size={20} color="var(--color-error)" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-text-primary mb-1">
                  Delete Color
                </h3>
                <p className="text-sm text-text-secondary">
                  Are you sure you want to delete "{color?.name}"? This action cannot be undone and will affect any projects using this color.
                </p>
              </div>
            </div>

            <div className="flex gap-3 justify-end">
              <Button
                variant="outline"
                onClick={() => setShowDeleteConfirm(false)}
              >
                Cancel
              </Button>
              <Button
                variant="destructive"
                onClick={handleDelete}
                iconName="Trash2"
                iconPosition="left"
                iconSize={14}
              >
                Delete Color
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ColorCard;